import { FC } from "react";
import { SPECIALITY_PHARMACY } from "src/constants/todos";
import { headerPorps } from "../types";



const PharmacyTableHeader: FC<headerPorps> = ({ changeIdOrder, queryParam,tableHeader }) => {
    const PHARMACY_COVERAGE_GROUP = "Specialty Pharmacy";
    const tableHeaders = tableHeader ?? [];

    const firstPharmacyCoverageIndex = tableHeaders.findIndex(
        (header) => header.group === PHARMACY_COVERAGE_GROUP
    );

    const lastPharmacyCoverageIndex = tableHeaders.reduce(
        (lastIndex, header, index) =>
            header.group === PHARMACY_COVERAGE_GROUP ? index : lastIndex,
        -1
    );

    const hasPharmacyCoverage =
        firstPharmacyCoverageIndex !== -1 && lastPharmacyCoverageIndex !== -1;

    const columnsBeforePharmacy = hasPharmacyCoverage
        ? firstPharmacyCoverageIndex
        : tableHeaders.length;

    const columnsAfterPharmacy = hasPharmacyCoverage
        ? tableHeaders.length - lastPharmacyCoverageIndex - 1
        : 0;

    const pharmacyCoverageColSpan = hasPharmacyCoverage
        ? lastPharmacyCoverageIndex - firstPharmacyCoverageIndex + 1
        : 0;

    return (
        <thead className="sticky-top z-1">
        <tr className="text-center align-items-center">
            {columnsBeforePharmacy > 0 && (
                <th colSpan={columnsBeforePharmacy} className="border-0"></th>
            )}

            {hasPharmacyCoverage && (
                <th
                    colSpan={pharmacyCoverageColSpan}
                    className="colspan-head text-center border-start"
                >
                    Dispense & Refill
                    <span className="border"></span>
                </th>
            )}

            {columnsAfterPharmacy > 0 && (
                <th colSpan={columnsAfterPharmacy} className="border-0"></th>
            )}
        </tr>

        <tr className="text-center">
            {tableHeaders.map((header) => {
                const isPharmacyCoverageColumn =
                    header.group === PHARMACY_COVERAGE_GROUP;

                const hasCoverageBorderStart =
                    hasPharmacyCoverage &&
                    tableHeaders[firstPharmacyCoverageIndex]?.value === header.value;

                return (
                    <th
                        key={header.value || header.label}
                        className={[
                            isPharmacyCoverageColumn ? " text-center colspan-head" : "",
                            // hasCoverageBorderStart ? "border-end-0" : "",
                        ]
                            .filter(Boolean)
                            .join(" ")}
                        onClick={
                            header.value !== ""
                                ? () => changeIdOrder(header.value)
                                : undefined
                        }
                    >
              <span
                  role={header.value === "" ? "textbox" : "button"}
                  className={
                      header.value === ""
                          ? "fw-bold fs-6 lh-base"
                          : "btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold"
                  }
              >
                {header.label}

                  {(queryParam as any).sort_by === header.value ? (
                      <i
                          className={`bi ${
                              (queryParam as any).direction === "desc"
                                  ? "bi-caret-down-fill"
                                  : "bi-caret-up-fill"
                          }`}
                      ></i>
                  ) : null}
              </span>
                    </th>
                );
            })}
        </tr>
        </thead>
    );
};

export default PharmacyTableHeader;